let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gKrx9")).then(() => parcelRequire('1oOVg'));